
import Component from '../../../assets/scripts/modules/component'

class ArticleAccordeonComponent extends Component {
  init () {
    this.buttons = [...this.element.querySelectorAll('.article-accordeon__question-title-button')]
    this.regions = [...this.element.querySelectorAll('.article-accordeon__question-content-container')]
    this.pageTitle = document.querySelector('.article-header__title').textContent

    this.initButtons()
  }

  initButtons () {
    for (const button of this.buttons) {
      const region = document.getElementById(button.getAttribute('aria-controls'))

      if (region) {
        button.addEventListener('click', () => {
          this.toggleRegion(button, region)
          if (typeof window._paq !== 'undefined') {
            window._paq.push(['trackEvent', this.pageTitle, 'Click', button.textContent])
          }
        })
      }
    }
  }

  toggleRegion (button = false, region = false) {
    if (!region && !button) {
      return
    }

    if (!region) {
      region = document.getElementById(button.getAttribute('aria-controls'))
    }

    if (!button) {
      button = document.querySelector(`[aria-controls="${region.id}"]`)
    }

    if (!region || !button) {
      return
    }

    if (button.getAttribute('aria-expanded') === 'true') {
      region.setAttribute('aria-hidden', true)
      button.setAttribute('aria-expanded', false)
    } else {
      region.setAttribute('aria-hidden', false)
      button.setAttribute('aria-expanded', true)

      const rect = region.getBoundingClientRect()
      window.scroll({ top: (window.pageYOffset + rect.top) - (window.innerHeight / 3), left: 0, behavior: 'smooth' })
    }
  }

  openAllRegions () {
    for (const button of this.buttons) {
      if (button.getAttribute('aria-expaneded') !== 'true') {
        const region = document.getElementById(button.getAttribute('aria-controls'))
        region.setAttribute('aria-hidden', false)
        button.setAttribute('aria-expanded', true)
      }
    }
  }
}

window.addEventListener('init-load', () => {
  for (const element of document.querySelectorAll('.article-accordeon')) {
    element.instance = element.instance || new ArticleAccordeonComponent(element)
  }
})
